<a [href]="appleStoreUrl" target="_blank">
  <img src="/assets/img/apple-store-badge.svg" alt="" class="img-fluid" />
</a>
